/** Format monétaire EUR partagé par les composants du dashboard ambassadeur. */
export function formatEur(amount: number): string {
  return `${amount.toLocaleString("fr-FR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} €`;
}
